import { render, staticRenderFns } from "./liveBroadcastStatistics.vue?vue&type=template&id=483cba2b&scoped=true&"
import script from "./liveBroadcastStatistics.vue?vue&type=script&lang=js&"
export * from "./liveBroadcastStatistics.vue?vue&type=script&lang=js&"
import style0 from "./liveBroadcastStatistics.vue?vue&type=style&index=0&id=483cba2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483cba2b",
  null
  
)

export default component.exports